/**
 * Copyright 2023 AutoZone, Inc.
 * Content is confidential to and proprietary information of AutoZone, Inc., its
 * subsidiaries and affiliates.
 */
import { isServer } from '@/utils/isServer';

export const clickTrack = (
  data: Record<
    string,
    string | number | undefined | boolean | null | Array<string | undefined | number | null>
  >,
) => {
  if (!isServer) {
    if (window.utag !== undefined) {
      window.utag.link(data);
    }
  }
};
